<template>
    <div v-if="showTranslationButton">
        <div class="col-12 d-flex justify-content-center" v-if="isLoading">
            <b-spinner variant="secondary" type="grow"/>
        </div>
        <post-translation
            :descriptionOnly="descriptionOnly"
            :post-id="postId"
            :title="title"
            :description="description"
            :showButtonLabel="trans('community.post_show_translation')"
            :hideButtonLabel="trans('community.post_hide_translation')"
            @getPostTranslation="getPostTranslation"
        />
    </div>
</template>

<script>
    import PostTranslation from "../molecules/PostTranslation"
    import { mapGetters } from "vuex";

    export default {
        name: "PostTranslationContainer",
        components: { PostTranslation },
        props:{
            descriptionOnly: Boolean,
            postId: Number,
            titleLocale: String,
            descriptionLocale: String
        },
        data() {
            return {
                title: '',
                description: '',
                isLoading: false
            }
        },
        computed: {
            ...mapGetters({
                locale: 'user/getLocale'
            }),
            showTranslationButton() {
                if ((this.titleLocale && this.descriptionLocale) === null) return false
                return (this.titleLocale || this.descriptionLocale) !== this.locale
            }
        },
        methods: {
            getPostTranslation() {
                this.isLoading = true
                this.$axios.post('/api/rest/translator', {postId : this.postId})
                
                .then((res) => {
                    this.title = res.data.title
                    this.description = res.data.description
                    this.isLoading = false
                })
                .catch((e)=>{
                    console.log(e);
                })
            
            }
        }
    }
</script>